const Lock01 = ({ size, color }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      width={size || "20"}
      height={size || "20"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color || "#374040"}
        d="M5 6.66699C5 3.90557 7.23858 1.66699 10 1.66699C12.7614 1.66699 15 3.90557 15 6.66699V7.6256C15.2355 7.6772 15.4615 7.75235 15.68 7.86364C16.3072 8.18322 16.8171 8.69315 17.1367 9.32036C17.3428 9.7248 17.4249 10.1554 17.4632 10.6238C17.5 11.0748 17.5 11.6284 17.5 12.2992V13.5348C17.5 14.2056 17.5 14.7592 17.4632 15.2102C17.4249 15.6786 17.3428 16.1092 17.1367 16.5136C16.8171 17.1408 16.3072 17.6508 15.68 17.9703C15.2755 18.1764 14.8449 18.2586 14.3765 18.2968C13.9255 18.3337 13.3719 18.3337 12.7011 18.3337H7.29894C6.62812 18.3337 6.07448 18.3337 5.62348 18.2968C5.15507 18.2586 4.72448 18.1764 4.32003 17.9703C3.69283 17.6508 3.18289 17.1408 2.86331 16.5136C2.65724 16.1092 2.5751 15.6786 2.53683 15.2102C2.49998 14.7592 2.49999 14.2056 2.5 13.5348V12.2992C2.49999 11.6284 2.49998 11.0748 2.53683 10.6238C2.5751 10.1554 2.65724 9.7248 2.86331 9.32036C3.18289 8.69315 3.69283 8.18322 4.32003 7.86364C4.53845 7.75235 4.76449 7.6772 5 7.6256V6.66699ZM13.3333 6.66699V7.50168H6.66667V6.66699C6.66667 4.82604 8.15905 3.33366 10 3.33366C11.8409 3.33366 13.3333 4.82604 13.3333 6.66699ZM10.8333 12.0837C10.8333 11.6234 10.4602 11.2503 10 11.2503C9.53976 11.2503 9.16667 11.6234 9.16667 12.0837V13.7503C9.16667 14.2106 9.53976 14.5837 10 14.5837C10.4602 14.5837 10.8333 14.2106 10.8333 13.7503V12.0837Z"
      />
    </svg>
  );
};
export default Lock01;
